import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Framework } from "@/components/site/Framework";
import { About } from "@/components/site/About";
import { CaseStudy } from "@/components/site/CaseStudy";
import { Partners } from "@/components/site/Partners";
import { LeadMagnet } from "@/components/site/LeadMagnet";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 antialiased">
      <Nav />
      <main>
        <Hero />
        <Services />
        <About />
        <Framework />
        <CaseStudy />
        <Partners />
        <LeadMagnet />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
